import React, { useState, useEffect } from "react";
import { useSnapshot } from "valtio";
import {
  eventsStore,
  datasetStore,
  layersStore,
  gmapStore,
} from "../managers/globalState";
import { METHANE_GMAP_ID } from "../helpers/processProjects";

import AnimationControls from "./animation_controls_btn";
import AnimationDate from "../components/animation_date";
import "../../www/assets/css/animation-controls.css";
import { useLocation } from "react-router-dom";

const animation_controls_wrapper = () => {
  const [isPlaying, setIsPlaying] = useState(true);
  const { animatedDate } = useSnapshot(eventsStore.state);
  const { datasetHasAnimation } = useSnapshot(datasetStore.state);
  const { state } = useLocation();
  const { notFirstPage } = state ?? {};
  const { currentEvent } = useSnapshot(eventsStore.state);
  const MethaneList = ["eo_event_00000", "eo_event_009900"];
  const SceneManager = getManager("scene");
  const isVisible = notFirstPage && Boolean(currentEvent);
  const [earthquakeDate, setEarthquakeDate] = useState(null);

  const isMethane = MethaneList.includes(currentEvent?.id);
  const { earthquakes } = layersStore.stateSnapshot;
  useEffect(() => {
    const updatePlayState = () => {
      if (window.animationManager) {
        setIsPlaying(window.animationManager.isPlaying);
      }
    };

    updatePlayState(); // Initial check
    const interval = setInterval(updatePlayState, 100);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    if (!earthquakes) return;

    setEarthquakeDate(SceneManager.getEarthquakeTime());

    const interval = setInterval(() => {
      setEarthquakeDate(SceneManager.getEarthquakeTime());
    }, 100);

    return () => clearInterval(interval);
  }, [earthquakes, SceneManager]);

  // // Add console log to debug
  // console.log('Animation status:', {
  //     datasetHasAnimation,
  //     hasAnimationManager: !!window.animationManager,
  //     isPlaying
  // });

  const handlePlayPause = () => {
    if (earthquakes === true) {
      setIsPlaying(!isPlaying);
      if (isPlaying) {
        SceneManager.pauseEarthquakeTimeline();
      } else {
        SceneManager.playEarthquakeTimeline();
      }
    } else if (window.animationManager) {
      window.animationManager.togglePlay();
      setIsPlaying(window.animationManager.isPlaying);
    }
  };

  const handlePrevious = () => {
    if (earthquakes === true) {
      SceneManager.previousEarthquake();
    } else if (window.animationManager) {
      window.animationManager.previous();
    }
  };

  const handleNext = () => {
    if (earthquakes === true) {
      SceneManager.nextEarthquake();
    } else if (window.animationManager) {
      window.animationManager.next();
    }
  };

  return (
    <div className="animation-control-div">
      {isMethane && (
        <>
          {" "}
          <AnimationControls
            isPlaying={isPlaying}
            onTogglePlay={handlePlayPause}
            onPrevious={handlePrevious}
            onNext={handleNext}
          />{" "}
        </>
      )}
      {isMethane ? <AnimationDate date={animatedDate} /> : null}
      {/* {animatedDate && <AnimationDate date={animatedDate} />} */}
    </div>
  );
};

export default animation_controls_wrapper;
